import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-report-quota-bar",
  templateUrl: "./report-quota-bar.component.html",
  styleUrls: ["./report-quota-bar.component.css"],
})
export class ReportQuotaBarComponent implements OnInit {
  @Input() current: number;
  @Input() limit: number;

  constructor() {}

  ngOnInit(): void {}
}
